<template>
    <div class="sui-scroll"
        :style="styleObj"
        @touchstart="touchstartEvent"
        @touchmove.passive="touchmoveEvent"
        @scroll.passive="scrollEvent">
        <slot></slot>
        <div class="sui--msdk"
            v-show="touchStart"></div>
    </div>
</template>

<script>
export default {
    name: 'sui-scroll',

    props: {

        // 是否为水平滚动
        horizontal: {
            type: Boolean,
            default: false
        },

        // overflowScrolling 属性
        overflowScrolling: {
            type: String,
            default: 'touch'
        },

        // 触发滚动到底部事件的距离
        onReachEndDistance: {
            type: Number,
            default: 200
        }

    },

    data() {
        return {

            // 当正在执行 touchstart 事件处理函数时锁定，避免因滑动过快导致未执行完即触发 touchomve 事件，导致触发全局滚动回弹
            lockTouchStart: false,

            touchStart: false, // 是否触发 touchStart 事件，MSDK BUG
            reachStart: false, // 是否滚动到起始端
            reachEnd: false, // 是否滚动到结束端
            originX: 0, // 触摸起始位置 X 坐标
            originY: 0, // 触摸起始位置 Y 坐标
            offset: 1, // 滚动判断非 px 单位容错量
            isIOS: window.navigator.userAgent.includes('Mac OS X'),

            // 暂存上一次滚动位置，用于在 keep-alive 切换时恢复
            position: 0,
        }
    },

    computed: {
        styleObj() {
            return {
                'overflow-x': this.horizontal ? 'auto' : 'hidden',
                'overflow-y': !this.horizontal ? 'auto' : 'hidden',
                '-webkit-overflow-scrolling': this.overflowScrolling
            }
        }
    },

    activated() {
        if (this.horizontal) {
            this.$el.scrollLeft = this.position
        } else {
            this.$el.scrollTop = this.position
        }
    },

    methods: {

        /**
         * touchstart 事件
         * @param {Object} event - 事件对象
         */
        touchstartEvent(event) {
            this.touchStart = true
            this.lockTouchStart = true
            const touch = event.targetTouches[0]
            this.originX = touch.clientX
            this.originY = touch.clientY
            
            // #region 竖向滚动
            if (this.horizontal) {
                this.lockTouchStart = false
            } else {
                
                // #region 判断是否在起始端
                if (this.$el.scrollTop < this.offset) {
                    if (this.isIOS && this.overflowScrolling) {
                        this.$el.scrollTop = this.offset
                    }
                    this.reachStart = true
                    requestAnimationFrame(() => {
                        this.lockTouchStart = false
                    })
                } else {
                    this.reachStart = false
                }
                // #endregion
                
                // #region 判断是否在结束端
                if (this.$el.scrollHeight - this.$el.offsetHeight - this.$el.scrollTop < this.offset) {
                    if (this.isIOS && this.overflowScrolling) {
                        this.$el.scrollTop -= this.offset
                    }
                    this.reachEnd = true
                    requestAnimationFrame(() => {
                        this.lockTouchStart = false
                    })
                } else {
                    this.reachEnd = false
                }
                // #endregion

                if (!this.reachStart && !this.reachEnd) {
                    this.lockTouchStart = false
                }
            }
            // #endregion

        },

        /**
         * touchmove 事件
         * @param {Object} event - 事件对象
         */
        touchmoveEvent(event) {
            this.touchStart = false

            if (this.lockTouchStart) {
                return
            }

            const touch = event.targetTouches[0]
            const offsetX = touch.clientX - this.originX
            const offsetY = touch.clientY - this.originY
            if (this.horizontal) {

                // #region 阻止滚动：在横向滚动区域进行竖向滚动
                if (offsetY != 0 && Math.abs(offsetX / offsetY) < 1) {
                    return
                }
                // #endregion

            } else {

                // #region 阻止滚动：内容不够
                if (this.$el.scrollHeight - this.$el.offsetHeight < this.offset) {
                    return
                }
                // #endregion

                // #region 阻止滚动：非 IOS 或者关闭滚动回弹
                if (!this.isIOS || !this.overflowScrolling) {
                    if (this.reachStart && offsetY > 0 || this.reachEnd && offsetY < 0) {
                        return
                    }
                }
                // #endregion
                
            }

            // 阻止事件冒泡以触发局部滚动
            event.stopPropagation()
        },

        /**
         * scroll 事件
         * @param {Object} event - 事件对象
         */
        scrollEvent(event) {
            if (this.horizontal) {
                this.position = this.$el.scrollLeft
                this.$emit('scroll', this.$el.scrollLeft, event)
                if (this.$el.scrollWidth - this.$el.offsetWidth - this.$el.scrollLeft < this.onReachEndDistance + this.offset) {
                    this.$emit('reachEnd')
                }
            } else {
                this.position = this.$el.scrollTop
                this.$emit('scroll', this.$el.scrollTop, event)
                if (this.$el.scrollHeight - this.$el.offsetHeight - this.$el.scrollTop < this.onReachEndDistance + this.offset) {
                    this.$emit('reachEnd')
                }
            }
        }
    }
}
</script>

<style lang="postcss">
.sui-scroll {
    height: 100%;

    /* #region MSDK 必须要进行页面重绘 scrollTop 赋值才会有效果 */
    .sui--msdk {
        position: fixed;
        right: 0;
        bottom: 0;
        width: 1px;
        height: 1px;
    }
    /* #endregion */
    
}
</style>